import {  getEsignDocumentDownload } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_Esign_DocumentDownloadThunk = createAsyncThunk(
  "reKyc_Esign_DocumentDownloadThunk",
  async ({ params, token }) => {
    try {
      const response = getEsignDocumentDownload(params, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
